import { IIconBase } from '..'

const eyePasswordIcon = ({
  color = '#333752',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/eye-slash'>
        <g id='eye-slash'>
          <path
            id='Vector'
            d='M9.68661 6.31328L6.31328 9.68661C5.87995 9.25328 5.61328 8.65995 5.61328 7.99995C5.61328 6.67995 6.67995 5.61328 7.99995 5.61328C8.65995 5.61328 9.25328 5.87995 9.68661 6.31328Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M11.8799 3.84633C10.7132 2.96633 9.3799 2.48633 7.9999 2.48633C5.64656 2.48633 3.45323 3.87299 1.92656 6.27299C1.32656 7.21299 1.32656 8.793 1.92656 9.733C2.45323 10.5597 3.06656 11.273 3.73323 11.8463'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M5.61328 13.0204C6.37328 13.3404 7.17995 13.5138 7.99995 13.5138C10.3533 13.5138 12.5466 12.1271 14.0733 9.72711C14.6733 8.78711 14.6733 7.20711 14.0733 6.26711C13.8533 5.92044 13.6133 5.59378 13.3666 5.28711'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_4'
            d='M10.34 8.4668C10.1666 9.4068 9.39996 10.1735 8.45996 10.3468'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_5'
            d='M6.31301 9.68652L1.33301 14.6665'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_6'
            d='M14.6665 1.33301L9.68652 6.31301'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default eyePasswordIcon
